import React from "react";
import { Modal, ModalBody } from 'reactstrap';
import Button2 from "components/CustomButtons/Button.js";

const ConfirmModal = ({ 
    isOpen, 
    toggle, 
    onConfirm, 
    title = "ยืนยันการบันทึกข้อมูล", 
    icon = "far fa-question-circle",
    isLoading = false 
}) => {
    return (
        <Modal toggle={toggle} isOpen={isOpen}>
            <div className="modal-header justify-content-center">
                <div>
                    <i
                        className={isLoading ? "fa fa-spinner fa-w-16 fa-spin fa-lg" : icon}
                        style={{ color: "blue", fontSize: "2em" }}
                    ></i>
                </div>
            </div>
            <ModalBody>
                <p style={{ textAlign: "center" }}>
                    {isLoading ? "กำลังดำเนินการ..." : title}
                </p>
            </ModalBody>
            <div className="modal-footer">
                <Button2
                    color="info"
                    type="button"
                    onClick={onConfirm}
                    disabled={isLoading}
                >
                    <h4>ยืนยัน</h4>
                </Button2>

                <Button2
                    color="danger"
                    type="button"
                    onClick={toggle}
                    disabled={isLoading}
                >
                    <h4>ยกเลิก</h4>
                </Button2>
            </div>
        </Modal>
    );
};

export default ConfirmModal;